module.exports = __webpack_public_path__ + "static/img/icon_social_ig.8d1e4096.svg";